import React from "react";
import { useSelector } from "react-redux";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import SubTitle from "app/components/common/typography/SubTitle";
import { RootState } from "app/lib/store/store";
import { useNavigate } from "react-router-dom";
import UserIcon from "app/assets/icons/UserIcon";
import BriefcaseIcon from "app/assets/icons/BriefcaseIcon";
import CopySimpleIcon from "app/assets/icons/CopySimpleIcon";

const sunnary = [
  {
    title: "Driver’s License and Passport",
    img: UserIcon,
  },
  {
    title: "Income verification documents (Recent payslips and tax returns) ",
    img: BriefcaseIcon,
  },
  {
    title:
      "Expense verification documents (details/statements of existing loans/credit cards) ",
    img: CopySimpleIcon,
  },
];

const VerifyApplication: React.FC = () => {
  const navigate = useNavigate();

  const { loanApplication } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );

  const handleSubmit = () => {
    if (loanApplication?.applicationType === "joint") {
      navigate(`/joint-personal-details`);
    } else {
      navigate(`/personal-details`);
    }
  };

  return (
    <div className="w-full  sm:w-[70%] xl:w-[45%] mx-auto text-center px-4 sm:px-0">
      <MainTitle title="Great!" />
      <h6 className="font-Poppins  text-[24px] sm:text-[32px] lg:text-[32px] color-[#313131] text-center font-bold mb-3">
        Verify your application
      </h6>
      <SubTitle title="This will take a few minutes and you’ll need to have the following documents on-hand" />

      {sunnary.map((item) => {
        return (
          <div
            key={item.title}
            className={`flex gap-4  items-center w-full  px-6 p-4 py-5 mb-2 rounded-[16px] cursor-pointer bg-[#F3F3F3]`}
          >
            <div>
              <item.img />
            </div>
            <div>
              <h6
                className={`text-[#313131] font-Mulish text-[14px] font-normal text-left sm:text-center lg:text-left`}
              >
                {item.title}
              </h6>
            </div>
          </div>
        );
      })}

      <div className="flex  my-10 sm:mt-12">
        <ContinueButton
          className="w-full sm:w-[85%] mx-auto"
          type="button"
          onClick={handleSubmit}
        >
          Next
        </ContinueButton>
      </div>
    </div>
  );
};

export default VerifyApplication;
